module.exports = __webpack_public_path__ + "img/add_arrange.f069ac98.png";